import React from "react"
import { Card, Col, ListGroup, Row } from "react-bootstrap"

export default function PatientSatuSehat({
    getData,
    getIdPatientSSP,
    getDataAppointmentPatient,
    getProvince,
    getCity,
    getRegency,
    getDistrict,
    hasError,
}) {
    return (
        <>
            <Card className="mb-4 shadow-sm border-secondary">
                <Card.Header as="h6" className="bg-secondary text-white small">
                    👤 Informasi Pasien
                </Card.Header>

                <Card.Body
                    style={{
                        maxHeight: "500px",
                        overflowY: "auto",
                        filter: hasError ? "blur(5px)" : "none",
                        pointerEvents: hasError ? "none" : "auto",
                        userSelect: hasError ? "none" : "auto",
                        opacity: hasError ? 0.6 : 1,
                        transition: "filter 0.3s ease, opacity 0.3s ease",
                    }}
                >
                    {/* Header - Nama & Status */}
                    <div className="mb-3">
                        <h6 className="fw-bold mb-1">
                            {getData?.first_name} {getData?.last_name}{" "}
                            <span className="badge bg-success ms-2">Verified</span>
                        </h6>
                        <div className="text-muted small">
                            {getData?.medical_record_code} ({getIdPatientSSP}){" "}
                            <b>{getDataAppointmentPatient?.id_patient_ssp}</b>
                        </div>
                    </div>

                    {/* Body - Details */}
                    <Row className="small">
                        <Col xs={6} className="mb-2">
                            <strong>NIK:</strong>
                            <div>{getData?.nic_number}</div>
                        </Col>

                        <Col xs={6} className="mb-2">
                            <strong>Gender:</strong>
                            <div>
                                {getData?.gender === "male"
                                    ? "Laki-laki"
                                    : getData?.gender === "female"
                                        ? "Perempuan"
                                        : "-"}
                            </div>
                        </Col>

                        <Col xs={6} className="mb-2">
                            <strong>Phone:</strong>
                            <div>{getData?.phone_number}</div>
                        </Col>

                        <Col xs={6} className="mb-2">
                            <strong>Date of Birth:</strong>
                            <div>{getData?.date_birth}</div>
                        </Col>

                        <Col xs={12} className="mb-2">
                            <strong>Email:</strong>
                            <div>{getData?.email || "Not provided"}</div>
                        </Col>

                        <Col xs={6} className="mb-2">
                            <strong>Provinsi:</strong>
                            <div>{getProvince}</div>
                        </Col>

                        <Col xs={6} className="mb-2">
                            <strong>Kabupaten/Kota:</strong>
                            <div>{getCity}</div>
                        </Col>

                        <Col xs={6} className="mb-2">
                            <strong>District:</strong>
                            <div>{getRegency}</div>
                        </Col>

                        <Col xs={6} className="mb-2">
                            <strong>Village:</strong>
                            <div>{getDistrict}</div>
                        </Col>

                        <Col xs={12}>
                            <strong>Address:</strong>
                            <div>{getData?.residence_address}</div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

        </>
    )
}